import { Alert, Card, SkeletonLoader } from '@payaca/ambrosia';
import { FC, type JSX } from 'react';

type Props = {
  isError: boolean;
};

const SettingsCardPlaceholder: FC<Props> = ({
  isError,
}: Props): JSX.Element => (
  <Card sizeVariant="lg">
    <Card.Body aria-busy={!isError}>
      {isError ? (
        <Alert colour="red">We couldn&apos;t load these settings.</Alert>
      ) : (
        <div className="flex flex-col gap-4">
          <SkeletonLoader.Input />
          <SkeletonLoader.Input />
        </div>
      )}
    </Card.Body>
  </Card>
);

export default SettingsCardPlaceholder;
